import dayjs, { DATE_FORMAT } from "../../dayjs";

export function formatDateWithDay(dateStr: string) {
  if (!dateStr) return "";

  const date = dayjs(dateStr);

  if (!date.isValid()) {
    return dateStr;
  }

  const formattedDate = date.format(DATE_FORMAT);

  const dayName = date.format("dddd");

  return `${formattedDate}, ${dayName.charAt(0).toUpperCase()}${dayName.slice(1)}`;
}
